// fix for second button in the page
import React, { useRef } from "react";
import ExportIcon from '../assets/img/manage_data/data_upload.svg';
// @ts-ignore
import { CSVLink } from "react-csv";
import Button from "./Button";

interface CSVDownloadProps extends React.HTMLAttributes<{}> {
  data: any;
  filename: string;
  disabled: boolean;
  headers: Array<{ label: string; key: string }>;
}

const CSVDownload3: React.FunctionComponent<CSVDownloadProps> = (props) => {
  const ref = useRef();
  const handleOnClick = () => {
    if (props.data.length > 0) {
      // @ts-ignore
      ref.current.link.click();
    }
  };

  return (<>
      <Button disabled={props.disabled} className="export-button" onClick={handleOnClick} style={{height: "100%"}}>
        <img
          src={ExportIcon}
          alt="Export Icon"
          className="export-icon"
        />
        Export Table
      </Button>
    <CSVLink
      uFEFF={false}
      target="_self" // needed for download in Safari
      className={props.className}
      data={props.data}
      filename={props.filename}
      headers={props.headers}
      ref={ref}
    >
    </CSVLink>
  </>
  );
};

export default CSVDownload3;
